import { ErrorHandler } from './errorHandler';
import { SupportChat } from './supportChat';
import ui from '@/settings/ui';

export type PostgradErrorToastOptions = {
  longMessage: boolean;
};

export const showPostgradErrorToast = (
  error: Error,
  message: string,
  options?: PostgradErrorToastOptions,
) => {
  ErrorHandler.showErrorMessage({
    error,
    customIcon: 'warning',
    customMessage: message,
    timer: 12000,
    customBackground: ui.colorPalette.darkestGray,
    showCancelButton: false,
    customClass: {
      container: SupportChat.isChatLoaded() ? 'postgrad-error-toast-moved-container' : '',
      icon: 'postgrad-error-toast-icon',
      closeButton: 'postgrad-error-toast-close-button',
      htmlContainer: 'postgrad-error-toast-title',
    },
    width: options?.longMessage ? 450 : undefined,
  });
};
